import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import gtmHandler from "AtomicUtils/gtmHandler"
import buttonStyles from "AtomicComponents/Button/Button.less"
import typographyStyles from "AtomicComponents/Typography/Typography.less"
import { withRadium, keyframes, gtmEvent } from "higher-order-components"
import { Hyperlink, Tabs, Button } from "components"
import { A, H5 } from 'AtomicComponents'
import { titleCase, compact, compactMap, formatPhoneNumber } from "utils"
import { Link } from "react-router-dom"

const HoursIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4S5.4 1.6 10 1.6s8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8s-6.8 3-6.8 6.8 3 6.8 6.8 6.8c1.8 0 3.5-.7 4.8-2s2-3 2-4.8zm-5.9-.3l3.5 2.2-.9 1.5-4.4-2.7V5h1.7v4.7z" />
  </svg>
)

const AddressIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z" />
  </svg>
)

const WebsiteIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5-4.3-1-5.9-2.5-2.5-3.7-2.5-6 1-4.4 2.5-6 3.7-2.5 6-2.5c2.2 0 4.4.9 6 2.5s2.4 3.8 2.4 6zM3.3 9.1h2.8c0-1.8.4-3.5.9-4.8.1-.2.2-.3.2-.5-.8.3-1.4.8-2 1.4-1.1 1.1-1.7 2.5-1.9 3.9zm1.9 5.7c.6.6 1.3 1.1 2 1.4 0-.2-.1-.3-.2-.5-.5-1.3-.9-3-.9-4.8H3.3c.2 1.4.8 2.8 1.9 3.9zM10 3.2c-.3 0-.9.5-1.4 1.7-.4 1.2-.7 2.6-.8 4.2h4.4c-.1-1.6-.4-3.1-.8-4.2 0-.1-.1-.1-.1-.2.8.2 1.5.6 2.2 1.1.2 1 .4 2.1.5 3.3h2.8c-.2-1.5-.8-2.9-1.9-3.9-1.4-1.3-3.1-2-4.9-2zm1.4 11.9c.5-1.1.7-2.6.8-4.2H7.8c.1 1.6.4 3.1.8 4.2.5 1.3 1.1 1.7 1.4 1.7s.9-.5 1.4-1.7zm5.3-4.2h-2.8c-.1 1.8-.4 3.5-.9 4.8-.1.2-.2.4-.2.5.8-.3 1.4-.8 2-1.4 1.1-1.1 1.7-2.5 1.9-3.9z" />
  </svg>
)

const PhoneIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M1.4 14.7c-.3-.9 0-1.5.9-1.9.6-.3 1.5-.7 2.2-1 .5-.2 1-.5 1.4-.6.2-.1.4-.2.7-.2.5 0 .9.4 1 .5l.9.9c.5-.3 1.4-.9 2.2-1.7s1.4-1.7 1.7-2.2l-.9-.9c-.7-.6-.6-1.2-.3-1.8.2-.4.4-.8.6-1.4.3-.7.7-1.6 1-2.2.1-.3.4-1 1.2-1 .2 0 .4.1.6.1 2 .6 4 2.1 4 4.2 0 2-1.6 5.7-4.6 8.6-3 3-6.6 4.6-8.6 4.6-1.9.1-3.5-2-4-4zm1.5-.4c.4 1.4 1.5 2.9 2.6 2.9 1.4 0 4.7-1.3 7.6-4.1 2.8-2.8 4.1-6.1 4.1-7.6 0-1.1-1.5-2.2-2.9-2.6-.3.6-.7 1.5-1 2.2-.2.5-.5 1-.6 1.3v.1l1.7 1.7-.2.5c0 .1-.8 1.6-2.3 3.1-1.5 1.5-3 2.2-3.1 2.3l-.5.2-1.7-1.7h-.1c-.3.2-.8.4-1.3.6-.9.4-1.7.8-2.3 1.1z" />
  </svg>
)

const InfoIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4 0-2.2.9-4.4 2.5-6s3.7-2.5 6-2.5c4.6 0 8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 3.7 3 6.8 6.8 6.8 1.8 0 3.5-.7 4.8-2s2-3 2-4.8zM9.1 5.7h1.7v1.7H9.1V5.7zm0 2.8h1.7v5.8H9.1V8.5z" />
  </svg>
)

const PlusIcon = props => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...props}>
    <path d="M6 0v6H0v2h6v6h2V8h6V6H8V0z" fillRule="evenodd" />
  </svg>
)

class LocationTile extends PureComponent {
  constructor() {
    super()
    this.state = {
      activeIndex: 0,
      isHovered: false
    }
  }
  componentDidMount() {
    this.props.getFirstLocationTileHeight &&
      this.props.getFirstLocationTileHeight(this.element.offsetHeight)
  }
  icon = (name, moreStyles) => {
    const style = {
      height: "1.3em",
      width: "1.3em",
      fill: "#999999",
      flexShrink: 0,
      ...moreStyles
    }
    switch (name) {
      case "hours":
        return <HoursIcon style={style} />
      case "address":
        return <AddressIcon style={style} />
      case "website":
        return <WebsiteIcon style={style} />
      case "phone":
        return <PhoneIcon style={style} />
      case "info":
        return <InfoIcon style={style} />
      case "plus":
        return <PlusIcon style={style} />
    }
  }
  handleInteraction = (event) => {
    const { onClick } = this.props
    if (event.type === "keydown" && event.key !== "Enter") return
    onClick(event, () => {
      this.forceUpdate()
    })
  }
  handleMouseEnter = () => {
    this.props.mouseEnter(this.props.index)
    this.setState({ isHovered: true })
  }
  handleMouseLeave = () => {
    this.props.mouseLeave(this.props.index)
    this.setState({ isHovered: false })
  }
  renderDetail = (detail, index) => {
    const { compact, active } = this.props
    const labels = Array.isArray(detail.label) ? detail.label : [detail.label]
    if (compact && !active && detail.name === "hours") return
    return (
      <li key={index} style={[styles.detailItem, styles.fadeIn]}>
        <div style={styles.iconWrapper}>{this.icon(detail.name)}</div>
        <div>
          {detail.name === "hours" && <strong>Opening hours:</strong>}
          {detail.href ? (
            <Hyperlink
              key={index}
              text={detail.label}
              href={detail.href}
              external={detail.external} />
          ) : (
              labels.map((label, index) => <div key={index}>{label}</div>)
            )}
        </div>
      </li>
    )
  }
  fullAddress() {
    const {
      address, suburb, state, postCode
    } = this.props
    const region = compact([state, postCode]).join(" ")
    return compactMap(titleCase, [address, suburb])
      .concat(region || [])
      .join(", ")
  }
  addressHref() {
    return `https://google.com.au/maps?q=${this.fullAddress().replace(/ /g, "+")}/`
  }
  render() {
    const {
      displayHours,
      message,
      name,
      compact,
      salesCTA,
      serviceCTA,
      emailCTA,
      selectCTA,
      websiteLabel,
      website,
      active,
      primaryCTA,
      departments,
      disableCategories,
      customDealerDescription,
      animateHeight = true,
      gtmEvent,
      gtm
    } = this.props
    let department;
    department = departments[localStorage.getItem('activeTabIndex') || this.state.activeIndex]
    let primaryButton;
    if (department) {
      primaryButton =
        primaryCTA ||
        (department.name !== "Parts" && (department.name === "Sales" ? salesCTA : serviceCTA))
    } else {
      department = departments[0]
    }
    return (
      <div
        data-test={"location-tile"}
        data-status={active ? "selected" : "deselected"}
        style={animateHeight ? [styles.wrapper((this.element && this.element.offsetHeight) || 0)] : []}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        <div
          style={[
            {
              padding: compact ? "2em" : "3em 4vw",
              display: "block",
              transition: "background .1s",
              cursor: "pointer",
              outline: 0
            },
            active && { background: "#fff" }
          ]}
          ref={(c) => {
            this.element = c
          }}
          onClick={this.handleInteraction}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <A
              withoutStyle
              tabIndex={0}
              onKeyDown={this.handleInteraction}
              style={styles.headingLink(active, this.state.isHovered)}>
              <H5 withDetails>
                {name}
              </H5>
            </A>
          </div>
          {compact && active && selectCTA}
          {compact && (
            <p
              style={{
                color: "#910A2D",
                fontWeight: "200",
                margin: "1em 0",
                lineHeight: "1.4"
              }}>
              {message}
            </p>
          )}
          {customDealerDescription ? (
            <div style={{ margin: "1em 0 2em" }}>{customDealerDescription}</div>
          ) : (
              !disableCategories && (
                <div style={{ marginLeft: "-0.5em" }}>
                  <Tabs
                    compact
                    divider
                    options={departments}
                    active={this.state.activeIndex}
                    onChange={(option, index) => {
                      gtmHandler({
                        pageCategory: gtm && gtm.category ? gtm.category : null,
                        pageAction: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "DEPARTMENT MENU ${departments[index].name.toUpperCase()}" - ${this.fullAddress()}` : null)
                      })
                      this.setState({ activeIndex: index })
                    }} />
                </div>
              )
            )}
          <ul style={{ padding: 0, listStyleType: "none", margin: "1.5em 0" }}>
            {this.fullAddress() && (
              <li style={[styles.detailItem, styles.fadeIn]}>
                <div style={styles.iconWrapper}>{this.icon("address")}</div>
                <div>
                  <Hyperlink
                    text={this.fullAddress()}
                    href={this.addressHref()}
                    external
                    gtm={{
                      category: gtm && gtm.category ? gtm.category : null,
                      action: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "ADDRESS ${this.fullAddress().toUpperCase()}" - ${departments.map(d => d.name).toString()} - ${this.fullAddress()}` : null)
                    }} />
                </div>
              </li>
            )}
            {displayHours &&
              department.hours.length > 0 && (
                <li style={[styles.detailItem, styles.fadeIn]}>
                  <div style={styles.iconWrapper}>{this.icon("hours")}</div>
                  <div>
                    <strong>Opening hours:</strong>
                    {department.hours.map((label, index) => (
                      <div style={{ margin: ".3em 0" }} key={index}>
                        {label}
                      </div>
                    ))}
                  </div>
                </li>
              )}
            {active &&
              websiteLabel && (
                <li style={[styles.detailItem, styles.fadeIn]}>
                  <div style={styles.iconWrapper}>{this.icon("website")}</div>
                  <div>
                    <Hyperlink
                      text={websiteLabel}
                      href={website}
                      external
                      gtm={{
                        category: gtm && gtm.category ? gtm.category : null,
                        action: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "WEBSITE ${websiteLabel.toUpperCase()}" - ${departments.map(d => d.name).toString()} - ${this.fullAddress()}` : null)
                      }} />
                  </div>
                </li>
              )}
            {active &&
              department.phone && (
                <li style={[styles.detailItem, styles.fadeIn]}>
                  <div style={styles.iconWrapper}>{this.icon("phone")}</div>
                  <div>
                    {compact && (
                      <Hyperlink
                        text={formatPhoneNumber(department.phoneLabel)}
                        href={`tel:${department.phone}`}
                        gtm={{
                          category: gtm && gtm.category ? gtm.category : null,
                          action: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "PHONE ${department.phoneLabel}" - ${departments.map(d => d.name).toString()} - ${this.fullAddress()}` : null)
                        }} />
                    )}
                    {!compact && <span>{formatPhoneNumber(department.phoneLabel)}</span>}
                  </div>
                </li>
              )}
            {!active && (
              <li style={[styles.detailItem, styles.fadeIn]}>
                <div style={styles.iconWrapper}>
                  {this.icon("plus", {
                    height: "14px",
                    width: "14px",
                    fill: "#101010"
                  })}
                </div>
                <div>
                  <Hyperlink
                    text={"More Info"}
                    style={{
                      color: "#101010",
                      fontWeight: "400",
                      ":hover": { color: "#484848" }
                    }}
                    onClick={this.handleInteraction} />
                </div>
              </li>
            )}
          </ul>
          {active && (
            <div style={[styles.fadeIn, , styles.buttons(compact)]}>
              {primaryButton &&
                primaryButton.label &&
                  (primaryButton.isMyMazdaLink ?
                  (
                    <Link
                      to={primaryButton.href}
                      className={classnames({
                        [typographyStyles.withoutStyle]: true
                      })}
                      style={{textDecoration: "none"}}>
                      <span
                        className={`Button ${classnames({
                          [buttonStyles.Button]: true,
                          [buttonStyles.ButtonBlackOutlined]: primaryButton.styleName === "blackOutlined",
                          [buttonStyles.ButtonBlack]: primaryButton.styleName === "black"
                        })}`}
                        onClick={() => {
                          gtmHandler({
                            pageCategory: gtm && gtm.category ? gtm.category : "MyMazda - Dealer",
                            pageAction: `DEALER BLOCK - clicked "${primaryButton.label.toUpperCase()}"`
                          })
                        }}>
                        {primaryButton.label}
                      </span>
                    </Link>
                  )
                  :
                  (
                    <Button
                      {...primaryButton}
                      display={compact ? "block" : "inline"}
                      gtm={{
                        category: gtm && gtm.category ? gtm.category : null,
                        action: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "CTA BUTTON ${primaryButton.label.toUpperCase()}" - ${departments.map(d => d.name).toString()} - ${this.fullAddress()}` : null)
                      }} />
                  ))
                }
              {emailCTA &&
                department.email && (
                  <div style={{padding: compact ? '16px 0 0 0' : '0 0 0 16px'}}>
                    <Button
                      {...emailCTA}
                      href={`mailto:${department.email}`}
                      display={compact ? "block" : "inline"}
                      gtm={{
                        category: gtm && gtm.category ? gtm.category : null,
                        action: gtm && gtm.action ? gtm.action : (gtm && gtm.category ? `${gtm.category} - ${name} - Clicked "CTA BUTTON ${emailCTA.label.toUpperCase()}" - ${departments.map(d => d.name).toString()} - ${this.fullAddress()}` : null)
                      }} />
                    </div>
                )}
              {!compact && active && selectCTA}
            </div>
          )}
          {!compact && (
            <p
              style={{
                color: "#910A2D",
                fontWeight: "200",
                margin: "1em 0",
                lineHeight: "1.4"
              }}>
              {message}
            </p>
          )}
        </div>
      </div>
    )
  }
}

LocationTile.defaultProps = {
  displayHours: true,
  displayExpand: true,
  mouseEnter: () => {},
  mouseLeave: () => {}
}

LocationTile.propTypes = {
  displayHours: PropTypes.bool,
  message: PropTypes.node,
  onClick: PropTypes.func,
  departments: PropTypes.array,
  active: PropTypes.bool,
  compact: PropTypes.bool,
  name: PropTypes.string,
  address: PropTypes.string,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func,
  index: PropTypes.number,
  suburb: PropTypes.string,
  state: PropTypes.string,
  postCode: PropTypes.string,
  website: PropTypes.string,
  websiteLabel: PropTypes.string,
  disableCategories: PropTypes.bool,
  serviceCTA: PropTypes.object,
  primaryCTA: PropTypes.object,
  salesCTA: PropTypes.object,
  emailCTA: PropTypes.object,
  selectCTA: PropTypes.node,
  customDealerDescription: PropTypes.string,
  getFirstLocationTileHeight: PropTypes.func,
  gtm: PropTypes.object
}

export default withRadium(gtmEvent())(LocationTile)

const animationDuration = (height, speed) => {
  const calculated = height / 100 / speed
  if (calculated > 0.666 && calculated < 1.5) return calculated
  return calculated > 1.5 ? 1.5 : 0.666
}

const fadeInKeyframes = keyframes({
  from: {
    opacity: 0
  }
})

const styles = {
  iconWrapper: {
    marginRight: "1em",
    display: "flex",
    width: "1.3em",
    justifyContent: "center"
  },
  detailItem: {
    display: "flex",
    fontWeight: 200,
    margin: "1em 0",
    lineHeight: "1.4"
  },
  compactMain: {
    flexDirection: "column"
  },
  main: {
    maxHeight: "calc(100vh - 101px)"
  },
  fadeIn: {
    display: 'flex',
    animation: "x .666s",
    animationName: fadeInKeyframes
  },
  buttons: compact => ({
    flexDirection: compact ? 'column' : 'row'
  }),
  detailsPanel: { flex: "0 0 50%", overflowY: "scroll" },
  compactMapPanel: { height: "100vw", order: "-1" },
  mapPanel: { flex: "0 0 50%" },
  headingLink: (active, isHovered) => ({
    color: active || isHovered ? "#101010" : "#999999",
    transition: "color .66s",
    ":focus": {
      textDecoration: "underline",
      outline: 0
    }
  }),
  wrapper: height => ({
    transition: `opacity ${animationDuration(height, 10)}s`,
    height: height,
    overflow: "hidden"
  })
}



// WEBPACK FOOTER //
// ./src/containers/location-tile/index.jsx